import { Calendar } from '@fullcalendar/core'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'
import axios from '../axios-on-rails'
import 'daterangepicker'

const Message = (() => {
  // Global variables
  let hideDays = []            // Days of the week not showing on FullCalendar
  let calendar = null          // FullCalendar
  let minTime  = null          // Start time is displayed on FullCalendar. Example: 9:00
  let maxTime  = null          // End time is displayed on FullCalendar. Example: 19:00
  let scheduleStartDate = null // Start date is selected on DateRangePicker and displayed on FullCalendar. Example: '2022-03-16'
  let scheduleEndDate   = null // End date is selected on DateRangePicker and displayed on FullCalendar. Example: '2022-03-22'

  // Reset lists free time is selected
  // View area: 選択中の候補日程　※3つ以上ご設定ください
  function resetListFreeTimeSelected() {
    $('div.none-free-time').hide()
    // $('div.list-free-time-area').hide()
    $('div.form-row-free-time').remove()
  }

  // Get time setting from setting form: 営業曜日・時間の変更
  // Type is params name: time_from or time_to
  // Return example: 19:00
  function getTime(type) {
    let hour   = $(`select#setting_${type}__4i`).val()
    let minute = $(`select#setting_${type}__5i`).val()
    return `${hour}:${minute}`
  }

  // Get setting hide days of week on FullCalendar from setting form: 営業曜日・時間の変更
  // 0: Sun, 1: Mon, 2: Tue, 3: Wed, 4: Thu, 5: Fri, 6: Sat
  // Return example: [0, 6]
  function getHideDays() {
    let arrHiddenDays = []
    $('input.days-of-week:checkbox:not(:checked)').each(function() {
      arrHiddenDays.push(parseInt($(this).val()))
    })
    return arrHiddenDays
  }

  // Get array days between scheduleStartDate and scheduleEndDate
  // Reject hidden days setting if hideDays.present?
  // Return example:
    // scheduleStartDate = '2022-03-16'
    // scheduleEndDate   = '2022-03-22'
    // hideDays          = [0, 6]
    // return ['2022-03-16', '2022-03-17', '2022-03-18', '2022-03-21', '2022-03-22']
  function loadListDays() {
    let arrDays   = []
    let startDate = moment(scheduleStartDate)
    let endDate   = moment(scheduleEndDate)
    let date      = startDate
    while (date < endDate) {
      arrDays.push(date.format('YYYY-MM-DD'))
      date = date.clone().add(1, 'day')
    }
    if (hideDays.length > 0) arrDays = arrDays.filter(date => !hideDays.includes(moment(date).day()))
    return arrDays
  }

  // Add row free time to selected area and set time
  // View area: 選択中の候補日程　※3つ以上ご設定ください
  function addRowFreeTimeToListSelected() {
    $('div.none-free-time').hide()
    $('div.list-free-time-area').show()
    $('div.form-row-free-time').remove()

    // Get all events on FullCalendar
    // Filter by time selected and add to 選択中の候補日程　※3つ以上ご設定ください area
    // Sorting by time ASC
    calendar.getEvents().filter(event => {
      return ['ClickFreeTime', 'ManualSelectTime'].includes(event.extendedProps.type)
    }).sort((a, b) => a.start - b.start).forEach((event, index) => renderRowFreeTimeSelected(event, index))
  }

  // Return date format 'YYYY-MM-DD' by moment.js
  function formatDate(value) {
    return moment(value).format('YYYY-MM-DD')
  }

  // Return datetime format 'YYYY-MM-DDTHH:mm' by moment.js
  function formatDatetime(value) {
    return moment(value).format('YYYY-MM-DDTHH:mm')
  }

  // Convert data for event to add on FullCalendar
  // Example event return: { id: '2022-03-17T10:002022-03-17T12:00', start: '2022-03-17T10:00', end: '2022-03-17T12:00', color: '#ffffff00', type: 'FreeTime', borderColor: '#17a2b8' }
  function settingEvent(start, end, type) {
    // Define color for events
    let color   = type === 'FreeTime' ? '#ffffff00' : '#17a2b8bf'
    let bdColor = '#17a2b8'

    // Format start and end datetime args
    let fmStart = formatDatetime(start)
    let fmEnd   = formatDatetime(end)
    return { id: `${fmStart}${fmEnd}`, start: fmStart, end: fmEnd, color: color, type: type, borderColor: bdColor }
  }

  // Check overlap schedule time
  // Return example:
    /* listTime = [
      {start: Thu Mar 24 2022 10:30:00 GMT+0700 (Indochina Time), end: Thu Mar 24 2022 10:45:00 GMT+0700 (Indochina Time)},
      {start: Thu Mar 24 2022 18:00:00 GMT+0700 (Indochina Time), end: Thu Mar 24 2022 20:00:00 GMT+0700 (Indochina Time)}
    ] */
    // timeCheck = Thu Mar 24 2022 10:30:00 GMT+0700 (Indochina Time)
    // return true
  function noOverlapTime(listTime, timeCheck) {
    let noOverlap = true
    listTime.forEach(event => { if (event.start < timeCheck && timeCheck < event.end) return noOverlap = false })
    return noOverlap
  }

  // Get free time events from user_schedules
  // user_schedules must be sorted ASC by key start time
  // Return array free time to add on FullCalendar
  function calcFreeTimeEvents(userSchedules, arrDays = null) {
    let freeTimeEvents = []
    let listDays       = arrDays || loadListDays()
    let interviewTime  = parseInt($('select#interview_time').val()) * 60 * 1000
    listDays.forEach(date => {
      // Select events by day
      let subEvents = []
      let startTime = new Date(`${date}T${minTime}`)
      let finalTime = new Date(`${date}T${maxTime}`)
      userSchedules.forEach(event => {
        if (event.start.includes(date) && event.end.includes(date)) subEvents.push(event)
      })
      if (subEvents.length === 0) {
        // If there is no events today, free time full day
        if (finalTime - startTime >= interviewTime)
          freeTimeEvents.push(settingEvent(`${date}T${minTime}`, `${date}T${maxTime}`, 'FreeTime'))
      } else {
        // Else calculator free time by datetime and format it to events
        let firstSchedule = new Date(subEvents[0].start)
        let endSchdule    = null
        if (firstSchedule - startTime >= interviewTime) {
          freeTimeEvents.push(settingEvent(`${date}T${minTime}`, subEvents[0].start, 'FreeTime'))
        }
        if (subEvents.length === 1) {
          endSchdule = new Date(subEvents[0].end)
          if (finalTime - endSchdule >= interviewTime) {
            freeTimeEvents.push(settingEvent(subEvents[0].end, `${date}T${maxTime}`, 'FreeTime'))
          }
        } else {
          // Find free space in list user schedules
          let dateEvents = subEvents.map(event => ({ start: new Date(event.start), end: new Date(event.end) }))
          let prev       = dateEvents[0]
          let current    = null
          let space      = null
          for (let i = 1; i < dateEvents.length; i++) {
            if (prev === dateEvents[dateEvents.length]) break
            current = dateEvents[i]
            space   = current.start - prev.end
            if (space >= interviewTime && noOverlapTime(dateEvents, prev.end)) {
              freeTimeEvents.push(settingEvent(prev.end, current.start, 'FreeTime'))
            }
            prev = current
          }

          // Get free time end of date
          endSchdule = dateEvents.sort((a, b) => b.end - a.end)[0].end
          if (finalTime - endSchdule >= interviewTime) {
            freeTimeEvents.push(settingEvent(endSchdule, `${date}T${maxTime}`, 'FreeTime'))
          }
        }
      }
    })
    return freeTimeEvents
  }

  // Recalculate free time in a day when user selects time
  function recalculateFreeTimeOfDate(calendar, eventTarget) {
    let eventsOfDay, freeTimeEvents

    // Get all events belong date selection
    eventsOfDay = calendar.getEvents().filter(event => {
      if (formatDate(event.start) === formatDate(eventTarget.start) && event.extendedProps.type === 'FreeTime')
        event.remove()
      return formatDate(event.start) === formatDate(eventTarget.start) && event.extendedProps.type !== 'FreeTime'
    }).sort((a, b) => a.start - b.start)
      .map(event => ({ start: formatDatetime(event.start), end: formatDatetime(event.end) }))

    // Recalculate free time in a day and add to fullCalendar
    freeTimeEvents = calcFreeTimeEvents(eventsOfDay, [formatDate(eventTarget.start)])
    freeTimeEvents.forEach(event => calendar.addEvent(event))
  }

  // Render schedule calendar
  // startDate and endDate require format YYYY-MM-DD
  function renderFullCalendar(eventDatas) {
    $('#calendar').remove()
    $('div.render-full-calendar-area').append('<div id="calendar"></div>')
    let calendarElm = document.getElementById('calendar')
    calendar = new Calendar(calendarElm, {
      plugins: [interactionPlugin, timeGridPlugin],
      initialView: 'timeGrid',
      visibleRange: { start: scheduleStartDate, end: scheduleEndDate },
      events: eventDatas,
      dayMaxEventRows: true,
      selectable: true,
      selectMinDistance: 1,
      allDaySlot: false,
      slotMinTime: minTime,
      slotMaxTime: maxTime,
      slotDuration: '00:15:00',
      contentHeight: 'auto',
      editable: false,
      hiddenDays: hideDays,
      headerToolbar: { left: '', center: '', right:  '' },
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: false,
      },
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      },
      eventOverlap: function() {},

      // Change title header
      dayHeaderContent: function(args) {
        let dayOfWeek  = moment(args.date).format('ddd')
        let dayNumber  = moment(args.date).format('DD')
        let htmlRender = `<div class='fc-date-of-week'>${dayOfWeek}</div><div class='fc-date-number'>${dayNumber}</div>`
        return { html: htmlRender }
      },

      // Called when manual selected time
      select: function(selectionInfo) {
        let interviewTime  = parseInt($('select#interview_time').val()) * 60 * 1000
        let maxDistance    = 720 * 60 * 1000 // max select is 720 minutes
        let distanceSelect = selectionInfo.end - selectionInfo.start

        // Return if distance selection < interview time || distance selection > 12 hours
        if (distanceSelect < interviewTime || distanceSelect > maxDistance) return

        // Add event selected
        this.addEvent(settingEvent(selectionInfo.start, selectionInfo.end, 'ManualSelectTime'))
        recalculateFreeTimeOfDate(this, selectionInfo)
        addRowFreeTimeToListSelected()
      },

      // Called when on click events
      eventClick: function(eventInfo) {
        let eventId = eventInfo.event._def.publicId
        let element = $(`button[data-id='${eventId}']`)
        let event   = null
        if (eventInfo.event.extendedProps.type === 'FreeTime' && element.length === 0) {
          event = this.getEvents().find(event => event._def.publicId === eventId)
          event.remove()
          this.addEvent(settingEvent(event.start, event.end, 'ClickFreeTime'))
          addRowFreeTimeToListSelected()
        }
      },

      // Called when hover on events
      eventMouseEnter: function(eventInfo) {
        if (eventInfo.event.extendedProps.type !== 'FreeTime') return
        $(eventInfo.el).addClass('event-hover-color')
      },

      eventMouseLeave: function(eventInfo) {
        if (eventInfo.event.extendedProps.type !== 'FreeTime') return
        $(eventInfo.el).removeClass('event-hover-color')
      }
    })

    $('#div-calendar').show()
    calendar.render()
  }

  // Generate HTML row free time and add to selected area
  function renderRowFreeTimeSelected(event, index) {
    let start       = moment(event.start)
    let end         = moment(event.end)
    let year        = start.format('YYYY')
    let month       = start.format('MM')
    let date        = start.format('DD')
    let hourOptions = ''
    Array.from(Array(24).keys()).forEach(num => {
      let hour = ("0" + num).slice(-2)
      return hourOptions += `<option value=${hour}>${hour}</option>`
    })

    // Append HTML row free time select into 選択中の候補日程　※3つ以上ご設定ください area
    $('div.list-free-time-area').append(
      `<div class="form-row-free-time row mb-2">
        <div class="col-lg-10 offset-lg-1 list-free-time-data">
          <div class="row align-items-center">
            <div class="col-2 date-text">${start.format('MM/DD(ddd)')}</div>
            <div class="col-4">
              <div class="d-flex">
                <input type="hidden" id="free_time_from_1i" name="free_time[${index}][from[(1i)]]" value=${year}>
                <input type="hidden" id="free_time_from_2i" name="free_time[${index}][from[(2i)]]" value=${month}>
                <input type="hidden" id="free_time_from_3i" name="free_time[${index}][from[(3i)]]" value=${date}>
                <select id="free_time_from_4i" name="free_time[${index}][from[(4i)]]" class="form-control custom-select mr-3">
                  ${hourOptions}
                </select>
                <select id="free_time_from_5i" name="free_time[${index}][from[(5i)]]" class="form-control custom-select mr-3">
                  <option value="00">00</option><option value="15">15</option><option value="30">30</option> <option value="45">45</option>
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="d-flex">
                <input type="hidden" id="free_time_to_1i" name="free_time[${index}][to[(1i)]]" value=${year}>
                <input type="hidden" id="free_time_to_2i" name="free_time[${index}][to[(2i)]]" value=${month}>
                <input type="hidden" id="free_time_to_3i" name="free_time[${index}][to[(3i)]]" value=${date}>
                <select id="free_time_to_4i" name="free_time[${index}][to[(4i)]]" class="form-control custom-select mr-3">
                  ${hourOptions}
                </select>
                <select id="free_time_to_5i" name="free_time[${index}][to[(5i)]]" class="form-control custom-select mr-3">
                  <option value="00">00</option><option value="15">15</option><option value="30">30</option> <option value="45">45</option>
                </select>
              </div>
            </div>
            <div class="col-2">
              <button name="button" type="button" class="btn btn-danger btn-delete-free-time" data-id=${event._def.publicId}>${gon.views.shared.btn_delete_txt}</button>
            </div>
          </div>
        </div>
      </div>`
    )

    // Set necessary value for row time select
    $('select#free_time_from_4i:last').val(start.format('HH'))
    $('select#free_time_from_4i:last').attr('prev', start.format('HH'))
    $('select#free_time_from_5i:last').val(start.format('mm'))
    $('select#free_time_from_5i:last').attr('prev', start.format('mm'))
    $('select#free_time_to_4i:last').val(end.format('HH'))
    $('select#free_time_to_4i:last').attr('prev', end.format('HH'))
    $('select#free_time_to_5i:last').val(end.format('mm'))
    $('select#free_time_to_5i:last').attr('prev', end.format('mm'))
  }

  // When apply date on date range picker
  function settingDateOnCalendar(picker) {
    // Start date slected
    let dateClick = picker.startDate.format('YYYY-MM-DD')

    // Set end date = start date + 7days on DateRangePicker
    picker.endDate = moment(dateClick).add(6, 'days')

    // Save global variable
    // Schedule date is displayed on FullCalendar
    scheduleStartDate = moment(dateClick).format('YYYY-MM-DD')
    scheduleEndDate   = moment(dateClick).add(7, 'days').format('YYYY-MM-DD')

    // Save scheduleStartDate to hidden input
    $('input#calendar_start_date').val(scheduleStartDate)
  }

  // Get participant_ids (interview participants)
  // Return example: ['17333', '20946']
  function userIdsSelected() {
    let userIds = [$('input#interview_participant_0').val()]
    $('select.interview_participants').each(function() {
      userIds.push($(this).find('option:selected').val())
    })
    return userIds.filter(id => id !== '')
  }

  // Rerender FullCalendar
  function progressRerenderFullCalendar(extraEvents = []) {
    // Save global variable
    // Date time from setting form to displayed on FullCalendar
    minTime  = getTime('time_from')
    maxTime  = getTime('time_to')
    hideDays = getHideDays()

    // Events data is displayed on FullCalendar
    // AJAX get data from database
    axios.get(Routes.interviews_calendar_company_user_events_path(
      { start_date: scheduleStartDate, end_date: scheduleEndDate, company_user_ids: userIdsSelected() }
    )).then(res => {
      let userSchedules  = res.data

      // Sorting data by start time ASC
      userSchedules      = [...userSchedules, ...extraEvents].sort((a, b) => new Date(a.start) - new Date(b.start))
      let freeTimeEvents = calcFreeTimeEvents(userSchedules)
      let eventDatas     = [...userSchedules, ...freeTimeEvents]
      renderFullCalendar(eventDatas)
      resetListFreeTimeSelected()

      // When click 変更 from confirm screen
      // Check params lists free time and re-add to 選択中の候補日程　※3つ以上ご設定ください
      if (!['', 'null'].includes($('input#calendar_lists_time').val())) {
        addRowFreeTimeToListSelected()
        $('input#calendar_lists_time').val('')
      }
    })
  }

  // Disabled HTML element
  function disableElm(element) {
    $(element).prop('disabled', true)
  }

  // Remove attribute disabled of HTML element
  function enableElm(element) {
    $(element).removeAttr('disabled')
  }

  // Convert time from time select params
  // Return example: '2022-03-17T19:00'
  function getTimeSelect(value) {
    return `${value['(1i)']}-${value['(2i)']}-${value['(3i)']}T${value['(4i)']}:${value['(5i)']}`
  }

  // Rollback setting form
  // Handle when close Modal 営業曜日・時間の変更
  function rollbackSettingForm() {
    $('input.days-of-week:checkbox').each(function() {
      // Revert hide days checkbox
      if (hideDays.includes(parseInt($(this).val()))) $(this).prop('checked', false)
      else $(this).prop('checked', true)
    })

    // Revert range time setting
    let startTime = minTime.split(':')
    let endTime   = maxTime.split(':')
    $('select#setting_time_from__4i').val(startTime[0])
    $('select#setting_time_from__5i').val(startTime[1])
    $('select#setting_time_to__4i').val(endTime[0])
    $('select#setting_time_to__5i').val(endTime[1])
  }

  // Handle when click button 再調整する
  function readjustIntreview() {
    let confirmArea = 'div.interview-schedule-confirm-area'
    let settingArea = 'div#setting-interview-area'

    // Un-checked radio button
    $(`${confirmArea} input.checkbox-event`).prop('checked', false)

    // Disable area have interview arrangement events data
    $(confirmArea).addClass('disable-area')
    disableElm(`${confirmArea} select`)
    disableElm(`${confirmArea} input`)
    disableElm(`${confirmArea} button`)

    // Display area setting interview
    $(settingArea).removeClass('hidden')
    enableElm(`${settingArea} select`)
    enableElm(`${settingArea} input`)
    enableElm(`${settingArea} button`)

    // Add button rollback readjust and params interview_readjust
    $('div.rollback-readjust-area').html(
      `<button class="mb-3 btn btn-danger btn-rollback-readjust" type="button">
        ${gon.views.shared.btn_stop_readjust_txt}
      </button>
      <input type="hidden" name="interview_readjust" value="true" class="interview-readjust" />`
    )
  }

  // Handle show and remove disabled attribute for interview setting area
  // Handle for applicant message
  function showInterviewArea(interviewArea) {
    $(interviewArea).removeClass('hidden')
    enableElm(`${interviewArea} select`)
    enableElm(`${interviewArea} input`)
    enableElm(`${interviewArea} button`)
    if ($('div#setting-interview-area').hasClass('hidden'))
      $('div.interview-schedule-confirm-area').removeClass('disable-area')
    if (!$('div#setting-interview-area').attr('style'))
      $('input.switch-hide-show-interview').prop('checked', true)
    if ($('div#setting-interview-area').hasClass('hidden'))
      $('input.switch-hide-show-interview').prop('checked', false)
  }

  // Handle hidden and add disabled attribute for interview setting area
  // Handle for applicant message
  function hideInterviewArea(interviewArea) {
    $(interviewArea).addClass('hidden')
    disableElm(`${interviewArea} select`)
    disableElm(`${interviewArea} input`)
    disableElm(`${interviewArea} button`)
    $('div.interview-schedule-confirm-area').addClass('disable-area')
    $('input.switch-hide-show-interview').prop('checked', false)
    $('input.interview-readjust').val('false')
  }

  // Handle hidden and add disabled attribute for interview setting area
  // Handle for scout message
  function scoutHideInterview() {
    $('div#scout-interview').addClass('hidden')
    disableElm('div.interview-area select')
    disableElm('div.interview-area input')
    disableElm('div.interview-area button')
  }

  // Handle show and remove disabled attribute for interview setting area
  // Handle for scout message
  function scoutShowInterview() {
    $('div#scout-interview').removeClass('hidden')
    enableElm('div.interview-area select')
    enableElm('div.interview-area input')
    enableElm('div.interview-area button')
  }

  // Call AJAX to check if member has scheduled an interview
  function hasInterviewArrangement(id, callback) {
    $.ajax({
      url: Routes.check_applicant_has_arrangement_interviews_interview_arrangements_path(),
      data: { member_application_id: id },
      success: (response) => { callback(response.is_applicant_has_arrangement) }
    })
  }

  class Message {
    constructor() {
      // Moment.js default is EN
      // Check current Language for handle Moment.js when window on load
      if (!window.location.pathname.split('/').includes('en')) moment.locale('ja')

      // Check hidden or show interview setting (日程調整) when window on load
      this.onInitialHideShowInterview()

      // When change select ステータス on applicant message
      this.onChangeMessageStatus()

      // Show DateRangePicker calendar when windown on load
      this.onInitDateRangePicker()

      // Handle when click button add interview participants (追加する)
      this.onAddInterviewParticipant()

      // Handle when change select interview participants (予定参加者)
      this.onChangeInterviewParticipant()

      // Handle when click button trash remove interview participants
      this.onRemoveInterviewParticipant()

      // Handle when change select length of interview (予定時間)
      this.onChangeInterviewTime()

      // Handle when click button 設定する on modal 営業曜日・時間の変更
      this.onSettingDatetime()

      // Handle when change days of week working of company (営業曜日・時間の変更)
      this.onChangeDateOfWeek()

      // Handle when change time working of company (営業曜日・時間の変更)
      this.onChangeTimeSetting()

      // Handle when click button キャンセル on modal 営業曜日・時間の変更
      this.onCancelSetting()

      // Handle when click button 空き時間を全て選択する
      this.onGetAllFreeTime()

      // Handle when click button 削除 on row free time (選択中の候補日程　※3つ以上ご設定ください area)
      this.onRemoveSelectFreeTime()

      // Handle order list time selected by TableDnD (confirm screen 希望日程　優先する順に並べてください)
      this.onOrderTimeSelected()

      // Handle when click switch button hide or show setting interview
      this.onSwitchSettingInterview()

      // Handle when click button 再調整する
      this.onResetSettingInterview()

      // Disabled interview setting (if satisfy the condition) when window on load
      this.onDisableParamsSettingInterview()

      // Handle when click button 再調整をやめる
      this.onRollbackReadjustInterview()

      // Handle when change time interview on 選択中の候補日程　※3つ以上ご設定ください area
      this.onChangeScheduleInterview()

      // Handle when click radio scout past (on scout message screen)
      this.onHideShowInterviewSendScoutMail()
    }

    // Load hide or show setting interview when access create message
    onInitialHideShowInterview() {
      let interviewArea     = 'div.setting-interview-time'
      let applicationStatus = $('[name="messages_message[member_application_status]"]:checked').val() ||
                              $('[name="messages_message[member_application_status]"]').val()
      let scoutStatus       = $('input.scout-past:checked').attr('data-status')
      if ($('div#scout-interview').length > 0 && scoutStatus &&
          ($('input#scout_new').is(':checked') || !['have_question', 'is_interested'].includes(scoutStatus))) {
        scoutHideInterview()
      }
      if (['first_interview', 'second_interview', 'third_interview', 'forth_interview'].includes(applicationStatus)) {
        $(interviewArea).removeClass('hidden')
      } else {
        disableElm(`${interviewArea} select`)
        disableElm(`${interviewArea} input`)
        disableElm(`${interviewArea} button`)

        if ($('div#scout-interview').length > 0) {
          enableElm(`${interviewArea} select`)
          enableElm(`${interviewArea} input`)
          enableElm(`${interviewArea} button`)
        }
      }
      if ($('input#display_interview').val() === 'false') {
        $('div.interview-area').addClass('hidden')
        disableElm('div.interview-area select')
        disableElm('div.interview-area input')
        disableElm('div.interview-area button')
      }
    }

    // Disabled params interview setting
    onDisableParamsSettingInterview() {
      let settingArea = 'div#setting-interview-area'
      if ($(settingArea).length === 0) return
      if ($(settingArea).attr('class') === 'hidden') {
        disableElm(`${settingArea} select`)
        disableElm(`${settingArea} input`)
        disableElm(`${settingArea} button`)
      }
    }

    // When change application status (on applicant message screen)
    onChangeMessageStatus() {
      $(document).on('change', '[name="messages_message[member_application_status]"], [name="messages_message[application_status]"]', function() {
        let selectBox = $('[name="messages_message[member_application_status]"]');
        if (selectBox.length === 0) selectBox = $('select#messages_message_member_application_status');
        let applicationStatus = $('[name="messages_message[member_application_status]"]:checked').val() || selectBox.val() ||
                                $('[name="messages_message[application_status]"]:checked').val();
        let interviewArea     = 'div.setting-interview-time'
        let previousValue     = selectBox.attr('data-before-change')
        let interviews        = ['first_interview', 'second_interview', 'third_interview', 'forth_interview']
        if (interviews.includes(applicationStatus)) {
          showInterviewArea(interviewArea)
          selectBox.attr('data-before-change', applicationStatus)
        } else {
          if (interviews.includes(previousValue)) {
            let member_application_id = selectBox.attr('member_application_id')
            hasInterviewArrangement(member_application_id, (is_applicant_has_arrangement) => {
              let confirmModal = $('.update-status-application')
              if (is_applicant_has_arrangement) {
                confirmModal.modal('show')
                confirmModal.on('click', '.btn-primary', () => {  // change
                  $.ajax({
                    url: Routes.delete_interview_arrangement_company_applicants_path(),
                    method: 'delete',
                    data: { id: member_application_id },
                    success: (response) => {
                      var url = new URL($(location).attr('href'))
                      url.searchParams.set('status', applicationStatus)
                      $(location).prop('href', url)
                    }
                  })
                })
                confirmModal.on('click', '.btn-outline-secondary', () => {  // cancel
                  showInterviewArea(interviewArea)
                  if (selectBox.tagName === 'select') {
                    selectBox.val(previousValue)
                  } else {
                    $(`#application_status_${applicationStatus}`).prop('checked', false);
                    $(`#application_status_${previousValue}`).prop('checked', true);
                  }
                  selectBox.attr('data-before-change', previousValue)
                })
                confirmModal.on('hidden.bs.modal', () => { confirmModal.off('click') })
              } else {
                hideInterviewArea(interviewArea)
                selectBox.attr('data-before-change', applicationStatus)
              }
            })
          } else {
            hideInterviewArea(interviewArea)
            selectBox.attr('data-before-change', applicationStatus)
          }
        }
      })
    }

    // Load DateRangePicker calendar when window on load
    onInitDateRangePicker() {
      if ($('#daterangepicker-selected').length === 0) return
      let picker = $('#daterangepicker-selected').daterangepicker({
        minDate: moment(),
        maxDate: moment().startOf('month').add(3, 'months').subtract(1, 'days'),
        parentEl: '#daterangepicker-container',
        autoApply: true,
        locale: {
          daysOfWeek: moment.weekdaysShort(),
          monthNames: moment.monthsShort()
        }
      })
      picker.on('apply.daterangepicker', function(_ev, picker) {
        if ($('div.list-free-time-area').children().length > 0) {
          if (confirm(gon.views.shared.confirm_before_setting)) {
            settingDateOnCalendar(picker)
            progressRerenderFullCalendar()
          } else {
            picker.startDate = moment(scheduleStartDate)
            picker.endDate   = moment(scheduleStartDate).add(6, 'days')
          }
        } else {
          settingDateOnCalendar(picker)
          progressRerenderFullCalendar()
        }
      })
      if ($('input#calendar_start_date').val()) {
        if ($('button.btn-resetup-interview').length > 0) readjustIntreview()
        let dateClick     = $('input#calendar_start_date').val()
        let schedules     = $.parseJSON($('input#calendar_lists_time').val()) || {}
        scheduleStartDate = dateClick
        scheduleEndDate   = moment(dateClick).add(7, 'days').format('YYYY-MM-DD')
        picker.data('daterangepicker').setStartDate(moment(dateClick))
        picker.data('daterangepicker').setEndDate(moment(dateClick).add(6, 'days'))
        schedules = Object.values(schedules).map((value) => {
          return settingEvent(getTimeSelect(value.from), getTimeSelect(value.to), 'ManualSelectTime')
        })
        progressRerenderFullCalendar(schedules)
      }
      picker.data('daterangepicker').hide = function() {}
      picker.data('daterangepicker').show()
    }

    // Addition select interview participant
    onAddInterviewParticipant() {
      $(document).on('click', 'button.btn-add-select-interview-participant', function() {
        let amount = $('select.interview_participants').length
        if (amount === 1 && $('div#participants-form-select').hasClass('d-none')) {
          $('div#participants-form-select').removeClass('d-none')
          $('div#participants-form-select').find('select').attr('disabled', false)
        } else if (amount === 4) {
          alert(gon.views.shared.cant_to_add)
          return
        } else {
          let htmlRender = $('select#interview_participant_1').closest('div.participant-item').prop('outerHTML')
          $('div#participants-form-select').append(htmlRender)
          $('select.interview_participants:last').val('')
          $('select.interview_participants:last').attr('id', `interview_participant_${amount + 1}`)
          $('select.interview_participants:last').attr('name', `interview_participant[${amount + 1}]`)
          $('select.interview_participants:last').attr('prev', '')
        }
      })
    }

    // When change interview participants
    onChangeInterviewParticipant() {
      $(document).on('change', 'select.interview_participants', function () {
        if (userIdsSelected().filter(id => id === $(this).val()).length > 1) {
          alert(gon.views.shared.this_company_user_is_seleted)
          $(this).val($(this).attr('prev'))
          return
        }
        if (!scheduleStartDate && !scheduleEndDate) {
          $(this).attr('prev', $(this).val())
          return
        } else {
          if ($('div.list-free-time-area').children().length > 0) {
            if (confirm(gon.views.shared.confirm_before_setting)) progressRerenderFullCalendar()
            else {
              $(this).val($(this).attr('prev'))
              return
            }
          } else progressRerenderFullCalendar()
          $(this).attr('prev', $(this).val())
        }
      })
    }

    // When click remove interview participant
    onRemoveInterviewParticipant() {
      $(document).on('click', 'button.btn-remove-participant', function() {
        let amount = $('select.interview_participants').length
        if (amount === 1) {
          if ($(this).closest('div.row').find('select').val() === '') {
            $('div#participants-form-select').addClass('d-none')
            $('div#participants-form-select').find('select').prop('disabled', true).val('')
          } else {
            if (confirm(gon.views.shared.confirm_before_remove_participant)) {
              $('div#participants-form-select').addClass('d-none')
              $('div#participants-form-select').find('select').prop('disabled', true).val('')
              if (scheduleStartDate && scheduleEndDate) progressRerenderFullCalendar()
            }
          }
        } else {
          if ($(this).closest('div.row').find('select').val() === '') {
            $(this).closest('div.row').remove()
          } else {
            if (confirm(gon.views.shared.confirm_before_remove_participant)) {
              $(this).closest('div.row').remove()
              if (scheduleStartDate && scheduleEndDate) progressRerenderFullCalendar()
            }
          }
        }

        // Replace index
        $('select.interview_participants').each(function(index) {
          $(this).attr('id', `interview_participant_${index + 1}`)
          $(this).attr('name', `interview_participant[${index + 1}]`)
        })
      })
    }

    // When change interview time
    onChangeInterviewTime() {
      $(document).on('change', 'select#interview_time', function() {
        if (!scheduleStartDate && !scheduleEndDate) {
          $(this).attr('prev', $(this).val())
          return
        }
        if ($('div.list-free-time-area').children().length > 0) {
          if (!confirm(gon.views.shared.confirm_before_setting)) {
            $(this).val($(this).attr('prev'))
            return
          }
        }
        progressRerenderFullCalendar()
        $(this).attr('prev', $(this).val())
      })
    }

    // When submit form datetime setting display
    onSettingDatetime() {
      $(document).on('click', 'button.submit-setting-datetime', function() {
        if ($('div.list-free-time-area').children().length > 0) {
          if (confirm(gon.views.shared.confirm_before_setting)) progressRerenderFullCalendar()
          else rollbackSettingForm()
        } else progressRerenderFullCalendar()
      })
    }

    // On change day of week before setting datetime
    onChangeDateOfWeek() {
      $(document).on('change', 'input.days-of-week', function() {
        if ($('input.days-of-week:checked').length === 0)
          $('button.submit-setting-datetime').attr('disabled', 'disabled')
        else $('button.submit-setting-datetime').removeAttr('disabled')
      })
    }

    // On change time before setting datetime
    onChangeTimeSetting() {
      $(document).on('change', 'select.setting-time-display', function() {
        let timeFromStr = getTime('time_from')
        let timeToStr   = getTime('time_to')
        let timeFrom    = new Date(0, 0, 0, timeFromStr.split(':')[0], timeFromStr.split(':')[1])
        let timeTo      = new Date(0, 0, 0, timeToStr.split(':')[0], timeToStr.split(':')[1])
        if (timeFromStr >= timeToStr || (timeTo - timeFrom < parseInt($('select#interview_time').val()) * 60 * 1000))
          $('button.submit-setting-datetime').attr('disabled', 'disabled')
        else $('button.submit-setting-datetime').removeAttr('disabled')
      })
    }

    // On cancel setting datetime
    onCancelSetting() {
      $(document).on('click', 'button.cancel-setting', function() {
        rollbackSettingForm()
        $('button.submit-setting-datetime').removeAttr('disabled')
      })
    }

    // Show list free time When click button get all
    onGetAllFreeTime() {
      $(document).on('click', 'button.btn-get-all-free-time', function() {
        let freeTimeEvents = calendar.getEvents().filter(event => event.extendedProps.type === 'FreeTime')
        if (freeTimeEvents.length === 0 && $('div.list-free-time-area').text() === '') {
          $('div.list-free-time-area').hide()
          $('div.none-free-time').show()
        }
        else if (freeTimeEvents.length === 0 && $('div.list-free-time-area').text() !== '') return
        else {
          freeTimeEvents.forEach(function(event) {
            event.remove()
            calendar.addEvent(settingEvent(event.start, event.end, 'ClickFreeTime'))
          })
          addRowFreeTimeToListSelected()
        }
      })
    }

    // When click button remove free time from list
    onRemoveSelectFreeTime() {
      $(document).on('click', 'button.btn-delete-free-time', function() {
        let newEvent = null
        let eventId  = $(this).attr('data-id')
        let event    = calendar.getEvents().find(event => event._def.publicId === eventId)
        event.remove()
        if (event.extendedProps.type === 'ClickFreeTime') {
          newEvent = settingEvent(event.start, event.end, 'FreeTime')
          calendar.addEvent(newEvent)
        } else recalculateFreeTimeOfDate(calendar, event)
        $(this).closest('div.form-row-free-time').remove()
      })
    }

    // Time selected table order
    onOrderTimeSelected() {
      if ($('table#order-time-selected').length === 0) return
      $('table#order-time-selected').tableDnD({
        onDragClass: 'table-drag-class',
        onDrop: function (table, row) {
          let timeSelects = ''
          $($(table).children()[0]).children().each(function(index) {
            let from = $(this).attr('from')
            let to   = $(this).attr('to')
            timeSelects += `<input type="hidden" name="free_time[${index}][from]" value=${from}></input>
                            <input type="hidden" name="free_time[${index}][to]" value=${to}></input>`
          })
          $('div#free_time_params_area').html(timeSelects)
          $(row).addClass('table-dropped-class')
          setTimeout(function() { $(row).removeClass('table-dropped-class') }, 1500)
        }
      })
    }

    // Switch button hide or show interview feature
    onSwitchSettingInterview() {
      $(document).on('click', 'input.switch-hide-show-interview', function() {
        let interviewArea = 'div.interview-area'
        if ($(this).is(':checked')) {
          $(interviewArea).removeClass('hidden')
          enableElm(`${interviewArea} select`)
          enableElm(`${interviewArea} input`)
          enableElm(`${interviewArea} button`)
          $('input#display_interview').val('true')
        } else {
          $(interviewArea).addClass('hidden')
          disableElm(`${interviewArea} select`)
          disableElm(`${interviewArea} input`)
          disableElm(`${interviewArea} button`)
          $('input#display_interview').val('false')
        }
      })
    }

    // Reset setting meeting schedule
    onResetSettingInterview() {
      $(document).on('click', 'button.btn-resetup-interview', function() {
        readjustIntreview()
      })
    }

    // Click rollback readjust interview
    onRollbackReadjustInterview() {
      $(document).on('click', 'button.btn-rollback-readjust', function() {
        let settingArea = 'div#setting-interview-area'
        let confirmArea = 'div.interview-schedule-confirm-area'
        $(settingArea).addClass('hidden')
        disableElm(`${settingArea} select`)
        disableElm(`${settingArea} input`)
        disableElm(`${settingArea} button`)
        $('input.interview-readjust').val('false')
        $(confirmArea).removeClass('disable-area')
        enableElm(`${confirmArea} select`)
        enableElm(`${confirmArea} input`)
        enableElm(`${confirmArea} button`)
        $(`${confirmArea} table.suggest-confirm input.checkbox-event`).each(function() {
          if ($(this).attr('data-accept') === 'false') {
            $(this).attr('disabled', true)
            $(this).closest('tr').find('select').prop('disabled', true)
          } else $(this).prop('checked', true)
        })
      })
    }

    // On change schedule selected row time_select
    onChangeScheduleInterview() {
      $(document).on(
      'change',
      'select#free_time_from_4i, select#free_time_from_5i, select#free_time_to_4i, select#free_time_to_5i',
      function() {
        let parentEl   = $(this).closest('div.form-row-free-time')
        let hourFrom   = parentEl.find('select#free_time_from_4i')
        let minuteFrom = parentEl.find('select#free_time_from_5i')
        let hourTo     = parentEl.find('select#free_time_to_4i')
        let minuteTo   = parentEl.find('select#free_time_to_5i')
        let timeFrom   = new Date(0, 0, 0, hourFrom.val(), minuteFrom.val())
        let timeTo     = new Date(0, 0, 0, hourTo.val(), minuteTo.val())
        let fixStart   = new Date(0, 0, 0, minTime.split(':')[0], minTime.split(':')[1])
        let fixEnd     = new Date(0, 0, 0, maxTime.split(':')[0], maxTime.split(':')[1])
        let itvTime    = parseInt($('select#interview_time').val()) * 60 * 1000
        if (timeFrom >= timeTo) {
          alert(gon.views.shared.end_time_greater_than_start_time)
          $(this).val($(this).attr('prev'))
        } else if (timeTo - timeFrom < itvTime) {
          alert(gon.views.shared.greater_than_or_eq_interview_time)
          $(this).val($(this).attr('prev'))
        } else if (timeFrom < fixStart || timeTo > fixEnd) {
          alert(gon.views.shared.without_time_confirmed)
          $(this).val($(this).attr('prev'))
        } else {
          $(this).attr('prev', $(this).val())
          let eventId  = parentEl.find('button.btn-delete-free-time').attr('data-id')
          let event    = calendar.getEvents().find(x => x._def.publicId === eventId)
          let date     = formatDate(event.start)
          let start    = `${date}T${hourFrom.val()}:${minuteFrom.val()}`
          let final    = `${date}T${hourTo.val()}:${minuteTo.val()}`
          let newEvent = settingEvent(start, final, 'ManualSelectTime')
          calendar.addEvent(newEvent)
          event.remove()
          parentEl.find('button.btn-delete-free-time').attr('data-id', `${start}${final}`)
          calendar.getEvents().filter((x) => {
            return formatDate(x.start) === date && x.extendedProps.type === 'FreeTime'
          }).forEach(x => x.remove())
          let uEvents = calendar.getEvents().filter((x) => {
            return formatDate(x.start) === date
          }).sort((a, b) => a.start - b.start).map(x => settingEvent(x.start, x.end, 'UserSchedule'))
          let remainFreetimes = calcFreeTimeEvents(uEvents, [date])
          remainFreetimes.forEach(freeTime => calendar.addEvent(freeTime))
        }
      })
    }

    // When select create new scout mail then hidden interview setting
    onHideShowInterviewSendScoutMail() {
      $(document).on('click', 'input#scout_new', function() {
        scoutHideInterview()
      })
      $(document).on('click', 'input.scout-past', function() {
        if ($('input#scout_new').is(':checked')) return
        if (['have_question', 'is_interested'].includes($(this).attr('data-status'))) {
          scoutShowInterview()
          $(`div.interview-schedule-confirm-area table.suggest-confirm input.checkbox-event`).each(function() {
            if ($(this).attr('data-accept') === 'false') {
              $(this).attr('disabled', true)
              $(this).closest('tr').find('select').prop('disabled', true)
            }
          })
        }
        else scoutHideInterview()
      })
    }

    selectFile(element) {
      let files = element.files;
      if (files.length > 0) {
        $(element).closest('.custom-filename').find('.filename').text(files[0].name);
      }
    }
  }
  return Message
})()

export default Message
